var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns is-multiline pt-6"},_vm._l((_vm.projects),function(project){return _c('router-link',{key:project._id,staticClass:"column is-4",attrs:{"to":{
                name: 'project',
                params: { projectId: project._id },
            },"tag":"div"}},[_c('project-card',{attrs:{"content":project}})],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }